<template>
  <Modal :id="'cmp-catalog-tracks-new_track_credit'" @cancelled="onCancel">
    <template slot="header">{{ item_name }}</template>

    <template slot="body">
      <div class="body-container">
        <div class="form-group">
          <TextField
            :id="'licence_line_date'"
            type="date"
            class="m1"
            v-bind="textFieldConfig"
            v-model="licence_line.licence_line_date"
            isModel
            :placeholder="$t('date')"
            @valuechanged="onTextFieldValueChange"
          />
          <Dropdown
            :id="'period'"
            class="m2"
            :options="licenceLinePeriodTV"
            :selected="
              licenceLinePeriodTV.find(
                (e) => e.value == licence_line.licence_line_period_txt
              )
            "
            :placeholder="$t('period')"
            box
            @selectedChange="
              (e) => onDropdownChange('licence_line_period_txt', e)
            "
          ></Dropdown>

          <TextField
            :id="'licence_line_year'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="licence_line.licence_line_year"
            isModel
            :placeholder="$t('year')"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            :id="'text'"
            type="textarea"
            class="m1"
            v-bind="textFieldConfig"
            v-model="licence_line.text"
            isModel
            :placeholder="$t('text')"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            :id="'sales_info'"
            type="textarea"
            class="m1"
            v-bind="textFieldConfig"
            v-model="licence_line.sales_info"
            isModel
            :placeholder="$t('sales_info')"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            :id="'qty_info'"
            type="textarea"
            class="m1"
            v-bind="textFieldConfig"
            v-model="licence_line.qty_info"
            isModel
            :placeholder="$t('qty')"
            @valuechanged="onTextFieldValueChange"
          />
          <Dropdown
            :id="'currency_id'"
            class="m2"
            :options="currencyTV"
            :selected="
              currencyTV.find((e) => e.value == licence_line.currency_id)
            "
            :placeholder="$t('currency')"
            box
            @selectedChange="(e) => onDropdownChange('currency_id', e)"
          ></Dropdown>
          <TextField
            :id="'statement_amount'"
            :inputType="'number'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="licence_line.statement_amount"
            isModel
            :placeholder="$t('Gross Amount')"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            :id="'reserve_amount'"
            :inputType="'number'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="licence_line.reserve_amount"
            isModel
            :placeholder="$t('Reserve Amount')"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            :id="'balance_amount'"
            :inputType="'number'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="licence_line.balance_amount"
            isModel
            :placeholder="$t('Balance Amount')"
            @valuechanged="onTextFieldValueChange"
          />
          <TextField
            :id="'invoice_amount'"
            :inputType="'number'"
            class="m1"
            v-bind="textFieldConfig"
            v-model="licence_line.invoice_amount"
            isModel
            :placeholder="$t('Invoice Amount')"
            @valuechanged="onTextFieldValueChange"
          />
        </div>
      </div>
    </template>

    <template slot="options">
      <button class="dt-button s6" @click.stop="onCancel">Cancel</button>
      <button class="dt-button v1 s6" @click.stop="onOkClick">Ok</button>
    </template>
  </Modal>
</template>

<script>
import Modal from "@dtplugins/modal/modal";
import InputField from "@plugins/text-field/input-field";
import NTable from "@/plugins/datatable/datatable";
import { mapGetterObject } from "../../../../store/global";
import { licenceGetters } from "../../store/licence/getters";
import { LicenceStoreNamespace as storeNS } from "../../store";
import { Subject } from "rxjs";
import {
  createNTableConfig,
  createTableHeader,
} from "../../../../plugins/datatable";
import { async } from "rxjs/internal/scheduler/async";

import { createTV } from "../../../../models/text-value.model";
import {
  createFormItemMixin,
  createFormModalMixin,
} from "../../../../dt-plugins/form-modal/form-modal";
import { licenceService } from "../../services/licence.service";
import { format } from "date-fns";
export default {
  components: {
    Modal,
    InputField,
    NTable,
  },
  props: ["selectedLicenceDetails"],
  mounted: async function () {
    if (this.mode == "edit") {
      const itemDetails = await licenceService.editLicenceLineForm(
        this.licence_id,
        this.licence_line_id
      );
      console.log({ itemDetails: itemDetails });
      this.details = itemDetails?.data;
      this.currencyList = itemDetails?.data?.currencies;
      this.licence_line = itemDetails?.data["licence_line"];
    } else {
      //const metaData = await licenceService.addLicenceLineForm(this.licence_id);
      const modal2Req = await licenceService.addLicenceLineModal2Data(this.licence_track_id);
      this.licence_line["text"] = this.selectedLicenceDetails?.licence_incomes.length > 0? "Licence Income": "Advance";
      (this.licence_line["licence_line_date"] = format(new Date(),"YYYY-MM-DD")),
      (this.currencyList = modal2Req?.data?.currencies);

      if (!this.licence_line.currency_id) {
        const licencesDetails =(this.licencesDetails || {})[this.licence_id] || {};
        const licence = licencesDetails.licence || {};
        const default_currency_id=licence.currency_id?licence.currency_id:licence.l_currency_id
        console.log(this.currencyList,"::::::::","this.currencyList[0]",licencesDetails)
        
        this.licence_line.currency_id = this.currencyList.find(x=>x.currency_id==default_currency_id).currency_id;
      }
      if (!this.licence_line.licence_line_period) {
        this.licence_line.licence_line_period = this.licenceLinePeriodTV[0].value;
      }
      
      this.external_table =modal2Req.data.external_table;
      this.item_name=modal2Req.data.item_name;
      this.external_id=modal2Req.data.external_id

      console.log(modal2Req,":::::modal2Req")
    }
  },
  data: function () {
    return {
      currencyList: [],
      external_table:'',
      item_name:'',
      external_id:''
    };
  },
  mixins: [
    createFormModalMixin(),
    createFormItemMixin({
      primary_key: "licence_line_id",
      itemKey: "licence_line",
      detailsHttpReq: null,
      addHttpReq: null,
      //licenceService.addLicenceLineForm
    }),
  ],
  computed: {
      ...mapGetterObject(storeNS, licenceGetters),

    licence_track_id:function(){
      return this.$route.query.licence_track_id;
    },
    licenceLinePeriodTV: function () {
      return [
        { text: "H1", value: "H1" },
        { text: "H2", value: "H2" },
        { text: "Q1", value: "Q1" },
        { text: "Q2", value: "Q2" },
        { text: "Q3", value: "Q3" },
        { text: "Q4", value: "Q4" },
        { text: "M1", value: "M1" },
        { text: "M2", value: "M2" },
        { text: "M3", value: "M3" },
        { text: "M4", value: "M4" },
        { text: "M5", value: "M5" },
        { text: "M6", value: "M6" },
        { text: "M7", value: "M7" },
        { text: "M8", value: "M8" },
        { text: "M9", value: "M9" },
        { text: "M10", value: "M10" },
        { text: "M11", value: "M11" },
        { text: "M12", value: "M12" },
      ];
    },
    currencyTV: function () {
      return createTV(this.currencyList, "currency_iso", "currency_id");
    },
    licence_id: function () {
      return this.$route.params.licence_id;
    },
    licence_line_id: function () {
      return this.$route.query.licence_line_id;
    },
  },
  methods: {
    onOkClick: async function () {
      if (this.mode == "add") {
        const res = await licenceService.addEditLicenceLine({
          action: "add_licence_line",
          ...this.licence_line,
          licence_id: this.licence_id,
          licence_track_id:this.licence_track_id,
          external_id:this.external_id,
          external_table:this.external_table,
          qty_info:parseFloat(this.licence_line.qty_info)==0?'':this.licence_line.qty_info
        });
        this.$emit("added", res.data);
      } else if (this.mode == "edit") {
        const res = await licenceService.addEditLicenceLine({
          action: "edit_licence_line",

          ...this.licence_line,
        });
        this.$emit("edited", this.licence_line);
      }
    },
    onCancel: function () {
      this.$emit("cancelled", true);
    },
    get_licence_line: function () {
      return {
        balance_amount: 0.0,
        statement_amount: 0.0,
        sales_info: null,
        qty_info:0,
        currency_id: null,
        reserve_amount: 0.0,
        fix_income_sys_curr: 0.0,
        invoice_line_id: null,
        licence_line_id: null,
        invoice_id: null,
        licence_id: null,
        licence_line_date: "",
        licence_line_year: "",
        text: "",
        licence_line_period_txt: "",
        invoice_amount: 0.0,
        royalty_date: null,
      };
    },
  },
};
</script>

<style lang="scss">
.cmp-catalog-tracks-search_product {
  .catalog-product_groups-add_products {
    border: 1px solid var(--sprt-5);
  }
}
</style>
